import Loading from "../main/Loading";
import { useDispatch, useSelector } from "react-redux";
import { fromJS } from "immutable";
import { useCurrentSize } from "../CurrentSize";
import { format, isToday, isValid } from "date-fns";
import ViewTrackingIcon from "../icons/ViewTracking";
import { systemLabels } from "./MessageListToolbar";
import ActivityAction from "../actions/ActivityAction";

export const formatEmailMessage = (dateString) => {
  const date = new Date(dateString);
  if (isValid(date)) {
    if (isToday(date)) {
      return format(date, "hh:mm aa");
    }
    return format(date, "d LLL");
  }
  return "";
};

const MessageList = ({ messages, loading }) => {
  const dispatch = useDispatch();
  const currentSize = useCurrentSize();
  const appId = useSelector((state: any) => state.inboxReducer.get("appId"));

  const handleOnClickMessage = (message) => {
    console.log(message.toJS());
    dispatch(ActivityAction.showActivityDialog(message.get("itemId"), message.get("id")));
    // dispatch(InboxAction.showMessageView(message));
    // dispatch(
    //   TaskAction.showRightPanelDialog(
    //     {
    //       messageId: message.get("id"),
    //       threadId: message.get("threadId"),
    //     },
    //     DialogTypes.sideMyInboxMessageDialog
    //   )
    // );
  };

  const getMessageHeader = (message, headerName) => {
    return message.getIn(["meta", headerName]) || "";
  };

  const isOutLook = (message) => {
    return message.get("type") == "OUTLOOK";
  };

  const renderEmailDate = (message) => {
    const dateField = isOutLook(message) ? "sentDateTime" : "Date";
    const dateString = getMessageHeader(message, dateField);
    return formatEmailMessage(dateString);
  };

  const renderEmailSubject = (message) => {
    const isUnread = (message.get("labelIds")?.toJS() || []).includes("UNREAD");
    const subjectField = isOutLook(message) ? "subject" : "Subject";
    const subject = getMessageHeader(message, subjectField);
    if (isUnread) {
      return <div className={"font-semibold leading-6 text-gray-900"}>{subject}</div>;
    }
    return <div className={"leading-6 text-gray-900"}>{subject}</div>;
  };

  const getFromEmail = (message) => {
    if (isOutLook(message)) {
      return message.getIn(["meta", "from", "emailAddress", "name"]);
    }
    const from = getMessageHeader(message, "From");
    const parts = from.split("<");
    if (parts.length > 0) {
      return parts[0];
    }
  };

  const renderEmailFrom = (message) => {
    const isUnread = (message.get("labelIds")?.toJS() || []).includes("UNREAD");
    const from = getFromEmail(message);
    if (isUnread) {
      return <div className={"font-semibold leading-6 text-gray-900 w-auto min-w-36"}>{from}</div>;
    }
    return <div className={"leading-6 text-gray-900 min-w-36"}>{from}</div>;
  };

  const getLabel = (labelId: string) => {
    return (
      systemLabels(appId).find((item) => item.id == labelId) || {
        name: "",
        color: "",
      }
    );
  };

  const renderLabels = (labels: any) => {
    return (
      <div className={"justify-center space-x-1"}>
        {labels.map((item: any) => {
          const label = getLabel(item);
          if (label.name == "") {
            return null;
          }
          return (
            <span
              key={item}
              onClick={() => {}}
              className={`${label.color} cursor-pointer max-w-32 inline-flex items-center gap-x-0.5 rounded-md bg-gray-50 px-2 py-1 text-xs font-medium ring-1 ring-inset ring-gray-500/10 truncate ...`}
            >
              {getLabel(item).name}
            </span>
          );
        })}
      </div>
    );
  };

  const renderTrackingMode = (message) => {
    if (message.get("tracking")) {
      return (
        <div className={"w-4 cursor-pointer"}>
          <ViewTrackingIcon className={"w-4 text-blue-600"} />
        </div>
      );
    }
    return (
      <div className={"w-4"} title={"No tracking"}>
        <ViewTrackingIcon className={"w-4 text-gray-300"} />
      </div>
    );
  };

  if (loading) {
    return <Loading />;
  }

  if (!messages || messages.size === 0) {
    return (
      <div className={"w-full h-full flex items-center justify-center text-gray-400"}>
        {"No messages found"}
      </div>
    );
  }

  const renderMessageItem = (message) => {
    return (
      <li
        key={message.get("id")}
        onClick={() => {
          handleOnClickMessage(message);
        }}
        className="flex flex-wrap items-center justify-between gap-x-6 gap-y-4 py-4 pl-4 sm:flex-nowrap hover:bg-gray-100"
      >
        <div>
          <div className="flex items-center gap-x-2 text-sm">
            <div className={"w-4"}>{renderTrackingMode(message)}</div>
            {renderEmailFrom(message)}
            <span>-</span>
            {renderEmailSubject(message)}
            <span className={"text-gray-600 flex w-auto"}>{message.get("snippet")}</span>
          </div>
        </div>
        <dl className="flex flex-none justify-between gap-x-8 w-auto">
          <div className="flex -space-x-0.5">
            {renderLabels(message.get("labelIds")?.toJS() || [])}
          </div>
          <div className="flex w-24 gap-x-2.5">
            <dt></dt>
            <dd className="text-sm leading-6 text-gray-900 font-semibold">
              {renderEmailDate(message)}
            </dd>
          </div>
        </dl>
      </li>
    );
  };

  const messageGroups = messages.groupBy((item) => item.get("threadId"));
  const messageComps = Object.entries(messageGroups.toJS()).map(([, values]): any => {
    const items = fromJS(values);
    if (items.size == 0) {
      return null;
    }
    if (items.size == 1) {
      return renderMessageItem(items.get(0));
    }
    const message = items.find((item) => item.get("tracking")) || items.get(0);
    return renderMessageItem(message);
  });
  return (
    <div className={"w-full pl-4 flex"} style={{ height: currentSize.height - 40 }}>
      <ul role="list" className="divide-y divide-gray-100 overflow-y-auto w-full">
        {messageComps}
      </ul>
    </div>
  );
};

export default MessageList;
